import PaywallContainer from "@/components/Paywall/PaywallContainer";

function PaywallPage() {
  return <PaywallContainer isFeaturePaywall />;
}

export default PaywallPage;
